import { render, staticRenderFns } from "./CpfCnpjField.vue?vue&type=template&id=3abc7523&"
import script from "./CpfCnpjField.vue?vue&type=script&lang=js&"
export * from "./CpfCnpjField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports